var lg_MKJ32022805_DVD = {
    name: "MKJ32022805_DVD",
    defaultCommandIndex: 1,
    commands: [
        {
            function: "KEY_POWER",
            name: "KEY_POWER",
            icon: "KEY_POWER",
            command: [68,0,4,93,2,106,6,93,2,250,1,197,17,93,17,92,2,215,173,55,107,118,170,186,250,226],
        },
        {
            function: "KEY_STOP",
            name: "KEY_STOP",
            icon: "KEY_STOP",
            command: [68,0,4,93,2,106,6,93,2,250,1,197,17,93,17,92,2,215,173,55,107,118,181,234,234,226],
        },
        {
            function: "KEY_PLAY",
            name: "KEY_PLAY",
            icon: "KEY_PLAY",
            command: [68,0,4,93,2,106,6,93,2,250,1,197,17,93,17,92,2,215,173,55,107,118,181,117,122,226],
        },
        {
            function: "KEY_PAUSE",
            name: "KEY_PAUSE",
            icon: "KEY_PAUSE",
            command: [68,0,4,93,2,106,6,93,2,250,1,197,17,93,17,92,2,215,173,55,107,118,170,245,234,226],
        },
        {
            function: "<<<",
            name: "<<<",
            icon: "<<<",
            command: [68,0,4,93,2,106,6,93,2,250,1,197,17,93,17,92,2,215,173,55,107,118,182,234,218,226],
        },
        {
            function: "KEY_REWIND",
            name: "KEY_REWIND",
            icon: "KEY_REWIND",
            command: [68,0,4,93,2,106,6,93,2,250,1,197,17,93,17,92,2,215,173,55,107,118,173,117,186,226],
        },
        {
            function: "KEY_FORWARD",
            name: "KEY_FORWARD",
            icon: "KEY_FORWARD",
            command: [68,0,4,93,2,106,6,93,2,250,1,197,17,93,17,92,2,215,173,55,107,118,186,234,186,226],
        },
        {
            function: ">>>",
            name: ">>>",
            icon: ">>>",
            command: [68,0,4,93,2,106,6,93,2,250,1,197,17,93,17,92,2,215,173,55,107,118,171,117,218,226],
        },
        {
            function: "KEY_MENU",
            name: "KEY_MENU",
            icon: "KEY_MENU",
            command: [68,0,4,93,2,106,6,93,2,250,1,197,17,93,17,92,2,215,173,55,107,118,187,90,183,98],
        },
        {
            function: "KEY_UP",
            name: "KEY_UP",
            icon: "KEY_UP",
            command: [68,0,4,93,2,106,6,93,2,250,1,197,17,93,17,92,2,215,173,55,107,118,189,90,175,98],
        },
        {
            function: "KEY_DOWN",
            name: "KEY_DOWN",
            icon: "KEY_DOWN",
            command: [68,0,4,93,2,106,6,93,2,250,1,197,17,93,17,92,2,215,173,55,107,118,170,214,247,98],
        },
        {
            function: "KEY_LEFT",
            name: "KEY_LEFT",
            icon: "KEY_LEFT",
            command: [68,0,4,93,2,106,6,93,2,250,1,197,17,93,17,92,2,215,173,55,107,118,181,218,235,98],
        },
        {
            function: "KEY_RIGHT",
            name: "KEY_RIGHT",
            icon: "KEY_RIGHT",
            command: [68,0,4,93,2,106,6,93,2,250,1,197,17,93,17,92,2,215,173,55,107,118,173,219,107,98],
        },
        {
            function: "KEY_OK",
            name: "KEY_OK",
            icon: "KEY_OK",
            command: [68,0,4,93,2,106,6,93,2,250,1,197,17,93,17,92,2,215,173,55,107,118,170,237,235,98],
        },
        {
            function: "KEY_1",
            name: "KEY_1",
            icon: "KEY_1",
            command: [68,0,4,93,2,106,6,93,2,250,1,197,17,93,17,92,2,215,173,55,107,118,187,213,106,226],
        },
        {
            function: "KEY_2",
            name: "KEY_2",
            icon: "KEY_2",
            command: [68,0,4,93,2,106,6,93,2,250,1,197,17,93,17,92,2,215,173,55,107,118,171,235,170,226],
        },
        {
            function: "KEY_3",
            name: "KEY_3",
            icon: "KEY_3",
            command: [68,0,4,93,2,106,6,93,2,250,1,197,17,93,17,92,2,215,173,55,107,118,183,213,170,226],
        },
        {
            function: "KEY_4",
            name: "KEY_4",
            icon: "KEY_4",
            command: [68,0,4,93,2,106,6,93,2,250,1,197,17,93,17,92,2,215,173,55,107,118,175,214,170,226],
        },
        {
            function: "KEY_5",
            name: "KEY_5",
            icon: "KEY_5",
            command: [68,0,4,93,2,106,6,93,2,250,1,197,17,93,17,92,2,215,173,55,107,118,191,170,170,226],
        },
        {
            function: "KEY_6",
            name: "KEY_6",
            icon: "KEY_6",
            command: [68,0,4,93,2,106,6,93,2,250,1,197,17,93,17,92,2,215,173,55,107,118,170,171,127,98],
        },
        {
            function: "KEY_7",
            name: "KEY_7",
            icon: "KEY_7",
            command: [68,0,4,93,2,106,6,93,2,250,1,197,17,93,17,92,2,215,173,55,107,118,181,86,191,98],
        },
        {
            function: "KEY_8",
            name: "KEY_8",
            icon: "KEY_8",
            command: [68,0,4,93,2,106,6,93,2,250,1,197,17,93,17,92,2,215,173,55,107,118,173,86,223,98],
        },
        {
            function: "KEY_9",
            name: "KEY_9",
            icon: "KEY_9",
            command: [68,0,4,93,2,106,6,93,2,250,1,197,17,93,17,92,2,215,173,55,107,118,186,173,95,98],
        },
        {
            function: "KEY_0",
            name: "KEY_0",
            icon: "KEY_0",
            command: [68,0,4,93,2,106,6,93,2,250,1,197,17,93,17,92,2,215,173,55,107,118,171,86,239,98],
        },
    ]
}
export default lg_MKJ32022805_DVD